<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-content">
      <ul class="o-sels j-payment-select-container">
        <li
          class="o-sels_sel"
          @click="selectPayMent(price)"
          v-for="(price, index) in targetPricesList"
          :key="index"
        >
          <i class="payment-sleect-icon select-money-icon"></i>
          {{ price.TRANS_AMOUNT }} {{ curPayType ? curPayType.show_currency : '' }}
          <span class="get-text" style="margin: 0 5px">=</span>
          <span
            v-if="
              price.PRODUCT_TYPE == 'coin' &&
              price.FIRST_PAY == 1 &&
              price.EXTRA_COIN != 0
            "
          >
            {{ price.SUB_COIN }}
            <i style="color: red">x 2 + {{ price.EXTRA_COIN }}</i>
          </span>
          <span
            v-if="
              price.PRODUCT_TYPE == 'coin' &&
              price.FIRST_PAY == 1 &&
              price.EXTRA_COIN == 0
            "
          >
            {{ price.SUB_COIN }}
            <i style="color: red">x 2</i>
          </span>
          <span
            v-if="
              price.PRODUCT_TYPE == 'coin' &&
              price.FIRST_PAY !== 1 &&
              price.EXTRA_COIN != 0
            "
          >
            {{ price.SUB_COIN }}
            <i style="color: red">+ {{ price.EXTRA_COIN }}</i>
          </span>
          <span
            v-if="
              price.PRODUCT_TYPE == 'coin' &&
              price.FIRST_PAY !== 1 &&
              price.EXTRA_COIN == 0
            "
          >
            {{ price.SUB_COIN }}
          </span>
          <span
            v-if="price.PRODUCT_TYPE == 'coin' && price.FIRST_PAY == 1"
            style="margin: 0 5px"
          >
            {{ coinName || '元寶' }}
            <i style="color: red">(首儲雙倍)</i>
          </span>
          <span
            v-if="price.PRODUCT_TYPE == 'coin' && price.FIRST_PAY != 1"
            style="margin: 0 5px"
          >
            {{ coinName || '元寶' }}
          </span>
          <span v-if="price.PRODUCT_TYPE == 'package'">
            {{
              price.CP_PRODUCT_DESC +
              (price.PRODUCT_EXTRA_DESC ? '-' + price.PRODUCT_EXTRA_DESC : '')
            }}
            <span style="color: red">
              {{ price.PRODUCT_DESC ? '(' + price.PRODUCT_DESC + ')' : '' }}
            </span>
          </span>
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import SelectContainer from '../../mixins/twSelectContainer';
import { getCoinName } from '../../store/twStore/storager';
export default {
  data() {
    return {
      coinName: getCoinName(),
      totalCount: 0
    };
  },
  computed: {
    targetPricesList() {
      // 产品需要按月卡、年卡、礼包、金币排序
      let pricesList = this.pricesList.slice();
      let coin = pricesList[0] || [];
      let targetCoinList = [];
      let packages = pricesList[1] || [];
      let targetPackageList = [];
      // 金币
      for (let i = 0; coin.list && i < coin.list.length; i++) {
        targetCoinList.push(coin.list[i]);
      }
      // 礼包(分为卡、非卡)
      let card = [];
      let other = [];
      for (let i = 0; packages.list && i < packages.list.length; i++) {
        if (packages.list[i].PRODUCT_ID.indexOf('card') !== -1) {
          card.push(packages.list[i]);
        } else {
          other.push(packages.list[i]);
        }
      }
      targetPackageList = [...card, ...other];
      return [...targetPackageList, ...targetCoinList];
    }
  },
  props: ['pricesList', 'curPrice', 'curPayType'],
  mixins: [SelectContainer],
  methods: {
    selectPayMent(price) {
      this.$emit('selectPayMent', price);
    }
  }
};
</script>
